import { useMemo } from 'react';
import acquisitionTypes from '../support/acquisitionTypes';
import ImageSizeOverridePolicy from '../support/policies/ImageSizeOverridePolicy';
import { useAsset } from './stateful/useAsset';
import { useAcquisitionType } from './stateful/useAcquisitionType';
import ImageSizeOverride from '../support/ImageSizeOverride';
import AssetSizeRule from '../support/AssetSizeRule';

const useImageSizeOverride = () => {
  const { asset } = useAsset();
  const { acquisitionType } = useAcquisitionType();

  const sizeOverride = useMemo(() => {
    const assetSizeRule = new AssetSizeRule(asset);

    return new ImageSizeOverride(new ImageSizeOverridePolicy(assetSizeRule));
  }, [asset]);

  const offerSize = useMemo(() => sizeOverride.offerSize(), [sizeOverride]);

  const eligibleImageSizeOverride = useMemo(() => {
    if (acquisitionType !== acquisitionTypes.LICENSE) {
      return false;
    }
    return sizeOverride.overrideDefaultSelection();
  }, [acquisitionType, sizeOverride]);

  return {
    eligibleImageSizeOverride,
    teeShirtSize: offerSize,
  };
};

export default useImageSizeOverride;
